export default function getFilteredIcons({ iconSet, iconSearch = '' }: any) {
  return iconSet.filter(
    (icon: any) =>
      (icon.key && icon.key.toLowerCase().includes(iconSearch.toLowerCase())) ||
      icon.props['data-search-terms']?.includes(iconSearch.toLowerCase())
  );
}
